export default __webpack_public_path__ + "static/media/properties-living-room-mobile.bd699bf6.png";